<template>
    <vue-modal
        v-model="visible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="false"
        :modalBodyClass="$prefixClass.modal + '-loading-screen-watch-demo'"
    >
        <loading-screen-tutorial @got-it="visible = false"></loading-screen-tutorial>
    </vue-modal>
</template>
<script>
import LoadingScreenTutorial from './LoadingScreenTutorial'
export default {
    name: 'ModalLoadingScreenWatchDemo',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LoadingScreenTutorial
    },
    data() {
        return {
        }
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set( value ) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
    }
}
</script>
<style lang="scss">
    .m-modal-loading-screen-watch-demo {
        width: 720px !important;
        .m-modal {
            &-content {
                border-radius: 8px;
            }
            &-body {
                padding: 0;
            }
        }
    }
</style>